
<template>
    <router-link class="d-inline-flex justify-content-center text-center vehicle-card py-2 px-2 rounded-4"
        :to="linkToMap ? '/home/' + balise.id : '/balise/' + balise.id" :class="{
            'vehicle-card-compact': compact,
            'vehicle-card-with-status': showStatuses,
            'disabled-link': !linkEnabled,
            'vehicle-card-no-hover': !hoverEffect
        }" :aria-disabled="!linkEnabled" @click="onClickLink">
        <!-- CONTENT -->
        <div class="flex-grow-1" style="min-width: 0;">
            <!-- COMPACT MODE -->
            <div v-if="compact" class="vehicle-compact">
                <div class="vehicle-compact-icon">
                    <VehicleIcon :icon="balise.icon" />
                </div>
                <div class="vehicle-compact-text">
                    <div class="vehicle-compact-name">
                        {{ balise.name }}
                    </div>
                    <div v-if="balise.immat" class="vehicle-compact-immat">
                        {{ balise.immat }}
                    </div>
                </div>
            </div>

            <!-- DEFAULT MODE -->
            <template v-else>
                <div class="h6 lh-1 mb-1 text-center link-dark">
                    {{ balise.name }}
                </div>
                <div v-if="balise.immat" class="d-inline-flex text-muted text-decoration-none small">
                    Immat : {{ balise.immat }}
                </div>

                <div class="d-flex flex-row mt-1 vehicle-default-row">
                    <div class="flex-column text-center align-self-center align-middle me-4 vehicle-default-icon">
                        <VehicleIcon :icon="balise.icon" />
                    </div>

                    <div class="flex-column text-start mb-1 vehicle-default-values">
                        <div v-if="balise.vehicle" class="text-muted small vehicle-default-value">
                            <VehicleTypeDisplay :vType="balise.vehicle" />
                        </div>
                        <div v-if="balise.make" class="text-muted small vehicle-default-value">
                            {{ balise.make }}
                        </div>
                        <div v-if="balise.model" class="text-muted small vehicle-default-value">
                            {{ balise.model }}
                        </div>
                        <div v-if="balise.color" class="text-muted small vehicle-default-value">
                            {{ balise.color }}
                        </div>
                        <div v-if="$isAdmin" class="text-muted small vehicle-default-value">
                            <IMEIDisplay :imei="balise.imei" />
                        </div>
                    </div>
                </div>

                <div class="text-center align-middle">
                    <div v-if="balise.groupId > 0" class="badge bg-secondary text-white small text-wrap">
                        {{ balise.groupName }}
                    </div>
                </div>
            </template>
        </div>

        <!-- STATUSES -->
        <div v-if="showStatuses" class="vehicle-status-separator"></div>

        <VehicleStatusesDisplay v-if="showStatuses" :balise="balise" />
    </router-link>
</template>

<script>
import VehicleIcon from '@/components/display/VehicleIcon.vue'
import IMEIDisplay from '@/components/display/IMEIDisplay.vue'
import VehicleTypeDisplay from '@/components/display/VehicleTypeDisplay.vue'
import VehicleStatusesDisplay from '@/components/display/VehicleStatusesDisplay.vue'

export default {
    components: {
        VehicleIcon,
        VehicleTypeDisplay,
        IMEIDisplay,
        VehicleStatusesDisplay
    },
    props: {
        balise: { required: true },
        linkToMap: { default: false },
        linkEnabled: { type: Boolean, default: true },
        compact: { type: Boolean, default: false },
        showStatuses: { type: Boolean, default: false },
        hoverEffect: { type: Boolean, default: true }
    },
    methods: {
        onClickLink(e) {
            if (!this.linkEnabled) e.preventDefault();
        }
    }
}
</script>

<style scoped>
/* Global clickable card */
.vehicle-card {
    max-width: 100%;
    text-decoration: none !important;
    color: inherit !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.vehicle-card:hover:not(.vehicle-card-no-hover) {
    background: rgba(0, 0, 0, 0.1);
    text-decoration: none !important;
    color: inherit !important;
}

/* prevent any child underline */
.vehicle-card * {
    text-decoration: none !important;
}

/* Compact mode */
.vehicle-compact {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    text-align: left;
    max-width: 100%;
    line-height: 1;
}

.vehicle-compact-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 50px;
    width: 50px;
    height: 50px;
}

.vehicle-compact-text {
    min-width: 0;
    flex: 1 1 auto;
    max-width: 100%;
}

.vehicle-compact-name {
    font-weight: 700;
    line-height: 1.1;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.vehicle-compact-immat {
    font-size: 12px;
    color: rgba(15, 23, 42, 0.6);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

/* Layout */
.vehicle-card-with-status {
    align-items: stretch;
    gap: 12px;
}

.vehicle-default-row {
    min-width: 0;
}

.vehicle-default-icon {
    flex: 0 0 auto;
}

.vehicle-default-values {
    min-width: 0;
}

.vehicle-default-value {
    line-height: 1.2;
}

/* Separator */
.vehicle-status-separator {
    flex: 0 0 1px;
    align-self: stretch;
    background: rgba(15, 23, 42, 0.08);
}

/* Icons */
.vehicle-compact-icon :deep(.icon-block) {
    width: 50px;
    height: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.vehicle-compact-icon :deep(.icon-mapdisplay) {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.vehicle-compact-icon :deep(svg) {
    width: 36px;
    height: 36px;
}

/* Disabled link */
.disabled-link {
    pointer-events: none;
    cursor: default;
}
</style>
